import { Component, computed, inject, input, ChangeDetectionStrategy } from "@angular/core";
import { UtilityService } from "@eforall/common";
import { DialogService, GridContentWidget } from "@eforall/dashboard";
import { ReadonlyAccessWidget } from "../../../../readonly-access/readonly-access.widget";
import { GoalDetailsDialogDataService } from "../goal-details-dialog-data.service";
import { getSetup } from "./grid/get-setup";

@Component({
	selector: 'goal-comments-part',
	standalone: true,
	imports: [
		GridContentWidget,
		ReadonlyAccessWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './comments.part.html'
})
export class GoalCommentsPart {

	private readonly util = inject(UtilityService);
	private readonly dialogService = inject(DialogService);
	public readonly dialogDataService = inject(GoalDetailsDialogDataService);

	public dialogBodyHeight = input.required<number>();

	// subtracting 60 to account for padding and tabstrip, also for readonly access bar if applicable 
	public customHeight = computed(() => this.dialogBodyHeight() - 60 - (this.dialogDataService.canEdit() ? 0 : 40));

	public setup = getSetup(this.util, this.dialogService, this.dialogDataService);

}